/**
 * `/manage` menu labels (§ Beheer). The pages themselves are WP-13's; this
 * WP only needs the section/item labels for `src/manage/navigation.ts`.
 */
export const manage = {
  backToApp: 'Back to app',
  sections: {
    companies: {
      label: 'Companies',
      items: {
        companies: 'Companies',
        pilots: 'Pilots',
      },
    },
    people: {
      label: 'People',
      items: {
        users: 'All users',
        linkIdentities: 'Link identities',
        admins: 'Administrators',
      },
    },
    audit: {
      label: 'Audit',
      items: {
        audit: 'Audit trail',
      },
    },
    subscriptions: {
      label: 'Subscriptions',
      items: {
        config: 'Provider configuration',
        products: 'Products & providers',
        userLedger: 'User ledger',
      },
    },
    system: {
      label: 'System',
      items: {
        statistics: 'Statistics status & rebuild',
        requests: 'API requests',
      },
    },
    support: {
      label: 'Support',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Overview',
      items: {
        overview: 'KPIs',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Statistics status & rebuild',
      note: 'Statistics status and rebuild controls are a plan of their own — this menu entry reserves the place, the screen is not built in fase 1.',
    },
  },
  usersAll: {
    title: 'All users',
    linkIdentities: 'Link identities',
    empty: 'No identities exist yet.',
    name: 'Name',
    email: 'E-mail',
    language: 'Language',
    login: 'Login',
    yes: 'yes',
    no: 'no',
    view: 'View',
    rowsLabel: 'the users',
  },
  linkIdentities: {
    title: 'Link duplicate identities',
    lead: 'The alias keeps existing but points at the primary. Unless you are a platform administrator, one of the two must be login-less and the identity with the login becomes the primary — the server checks this, whatever is chosen here.',
    candidatesLabel: 'the people you administer',
    needTwo: 'You need at least two people in your scope to link.',
    aliasLabel: 'Alias (this identity becomes the pointer)',
    primaryLabel: 'Primary (the identity that remains)',
    choose: 'Choose…',
    hasLogin: '(has login)',
    noLogin: '(no login)',
    link: 'Link',
    cancel: 'Cancel',
  },
  erase: {
    completedTitle: 'Erasure completed',
    completedText:
      'The identity is erased. The audit trail is pseudonymised, not deleted; linked identities survive with their pointer reset.',
    departmentsWithoutAdmin: 'Departments left without an administrator: {{names}}',
    measurementsNotDeleted:
      'Measurements in the ingest service were NOT deleted — that capability does not exist there yet. Follow this up outside the dashboard.',
    backToUsers: 'Back to users',
    title: 'Erase this person',
    lead: 'This irreversibly hard-deletes the identity {{userId}}: its user row, memberships, consents and grants. Linked identities survive; Gengee-originated data stays; the audit trail is pseudonymised. Type {{confirmWord}} to confirm.',
    confirmWord: 'ERASE',
    confirmationLabel: 'Confirmation',
    erasePermanently: 'Erase permanently',
    cancel: 'Cancel',
  },
  requests: {
    title: 'API requests',
    lead: "The ingest API's logged requests for a source, most recent first, optionally narrowed to a time window.",
    filterSource: 'Filter by source',
    sourcePlaceholder: 'source id',
    filterFrom: 'From',
    filterTo: 'To',
    filter: 'Filter',
    enterSourceHint: 'Enter a source id to load its request log.',
    empty: 'No requests logged for this source and window.',
    when: 'When',
    method: 'Method',
    path: 'Path',
    status: 'Status',
    rowsLabel: 'the requests',
  },
} as const;
